import { Validator } from "lakmus"
import { repository } from 'redux-scaffolding-ts'
import { FormStore } from 'src/core/stores/formStore'
import { container } from 'src/inversify.config'
import HttpService from '../core/services/http.service'
import { CommandResult } from '../core/stores/types'

export interface NewTooltipItem {
  name: string
  text: string
}

export interface TooltipItem extends NewTooltipItem {
  id: string
}

export class TooltipValidator extends Validator<TooltipItem> {
  constructor() {
    super()

    this.ruleFor(x => x.text)
      .notNull()
      .withMessage("Tooltip must have a text to show")

    this.ruleFor(x => x.name)
      .notNull()
      .withMessage("Tooltip must have a name")
  }
}

const TOOLTIP_UPDATE_ITEM = "TOOLTIP_UPDATE_ITEM"
@repository("@@TOOLTIPS", "tooltips.detail")
export class TooltipStore extends FormStore<TooltipItem> {
  baseUrl: string = `${process.env.PUBLIC_URL}/api/v1/tooltips`;
  private cachetooltipslang: [TooltipItem, string][]
  protected validate(item: TooltipItem) {
    return new TooltipValidator().validate(item)
  }

  constructor() {
    super('TOOLTIP', {
      isBusy: false,
      status: 'New',
      item: undefined,
      result: undefined
    }, container)
    this.cachetooltipslang = []
    this.addReducer(TOOLTIP_UPDATE_ITEM, (): any => {
      return super.onPatch()
    }, 'AsyncAction')
  }

  public changeUrl() {
    this.baseUrl = `${process.env.PUBLIC_URL}/api/v1/tooltips`
  }

  public async getById(id: string, params?: any): Promise<TooltipItem> {
    let cacheItem = this.cachetooltipslang.find(x => x[0].id == id && x[1] == HttpService.language)
    if (cacheItem) return cacheItem[0];
    var httpService = this.container.get<HttpService>(HttpService)
    const result = await this.dispatchAsync(this.ENTITY_LOAD, httpService.get<TooltipItem>(`${this.baseUrl}/${id}`, params))
    this.cachetooltipslang.push([result.data, HttpService.language])
    return result.data
  }

  public async getByName(name: string, params?: any): Promise<TooltipItem> {
    var httpService = this.container.get(HttpService)
    let cacheItem = this.cachetooltipslang.find(x => x[0].name == name && x[1] == HttpService.language)
    if (cacheItem) return cacheItem[0]
    const result = await this.dispatchAsync(this.ENTITY_LOAD, httpService.get<TooltipItem>(`${this.baseUrl}/name/${name}`, params))
    this.cachetooltipslang.push([result.data, HttpService.language])
    return result.data
  }

  public async update(item: TooltipItem) {
   
    var result = await super.patch(TOOLTIP_UPDATE_ITEM, `${item.id}`, item) as any
    let cacheItem = this.cachetooltipslang.find(x => x[0].id == item.id && x[1] == HttpService.language)
    if (cacheItem) cacheItem[0].text = item.text

    return result.data as CommandResult<TooltipItem>
  }
}